export default "__VITE_ASSET__BRaGneZt__"